import { ButtonGroup } from 'bold-ui'
import { ButtonLink } from 'components/route'
import { useLocation } from 'react-router'
import { matchPath } from 'react-router-dom'
import { TERRITORIO_TABS_ROUTE, TerritorioViewTabEnum } from 'view/visualizacaoTerritorial/model'
import {
  FILTROS_AVANCADOS_MODAL_ROUTE,
  PINO_TERRITORIO_MODAL_ROUTE,
} from 'view/visualizacaoTerritorial/territorio-mapas/model-territorioMapa'

interface TerritorioContentSwitchProps {
  baseUrl: string
}

export function TerritorioContentSwitch(props: Readonly<TerritorioContentSwitchProps>) {
  const { baseUrl } = props

  const location = useLocation()

  const listaDeImoveisUrl = `${baseUrl}/${TERRITORIO_TABS_ROUTE[TerritorioViewTabEnum.LISTA_DE_IMOVEIS]}`
  const mapaDoTerritorioUrl = `${baseUrl}/${TERRITORIO_TABS_ROUTE[TerritorioViewTabEnum.MAPA_DO_TERRITORIO]}`

  const isListaDeImoveisActive = !!matchPath(location.pathname, { path: listaDeImoveisUrl, exact: true })
  const isMapaDoTerritorioActive = !!matchPath(location.pathname, {
    path: [
      `${mapaDoTerritorioUrl}/:mapaSidebarNavItem?/${PINO_TERRITORIO_MODAL_ROUTE}/:imovelId(\\d+)`,
      `${mapaDoTerritorioUrl}/:mapaSidebarNavItem?/:filtrosAvancados(${FILTROS_AVANCADOS_MODAL_ROUTE})?`,
    ],
    exact: true,
  })

  return (
    <ButtonGroup>
      <ButtonLink size='small' kind={isListaDeImoveisActive ? 'primary' : 'normal'} to={listaDeImoveisUrl}>
        Lista de imóveis
      </ButtonLink>
      <ButtonLink size='small' kind={isMapaDoTerritorioActive ? 'primary' : 'normal'} to={mapaDoTerritorioUrl}>
        Mapa do território
      </ButtonLink>
    </ButtonGroup>
  )
}
